import css from 'styled-jsx/css';

export const breadcrumbsStyles = css`
  .breadcrumbs {
    display: flex;
    align-items: center;
    font-family: 'Lato', Arial, sans-serif;
    color: #666666;
  }

  .breadcrumbs :global(button) {
    display: none;
  }

  .breadcrumbs :global(li) {
    color: #666666 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    text-decoration: none !important;
  }

  .breadcrumbs :global(li:last-child) {
    font-weight: 700 !important;
  }

  .breadcrumbs :global(a) {
    color: #666666 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    text-decoration: none !important;
  }
`;
